import { render } from "./Suppliers.vue?vue&type=template&id=895cf3ac&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"

import "./Suppliers.vue?vue&type=style&index=0&id=895cf3ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-895cf3ac"

export default script